import '../App.css';

import Carousel from 'react-bootstrap/Carousel';

const Banner = () => {
    return (
        <Carousel id='banner_box' variant='dark'>
            <Carousel.Item className='box1'>
                <img src='https://kimsikyoung.github.io/images/HaiRound/img/banner1.png' alt='슬라이드1' />
            </Carousel.Item>
            <Carousel.Item className='box1'>
                <img src='https://kimsikyoung.github.io/images/HaiRound/img/banner2.png' alt='슬라이드2' />
            </Carousel.Item>
            <Carousel.Item className='box1'>
                <img src='https://kimsikyoung.github.io/images/HaiRound/img/banner3.png' alt='슬라이드3' />
            </Carousel.Item>
            <Carousel.Item className='box1'>
                <img src='https://kimsikyoung.github.io/images/HaiRound/img/banner4.png' alt='슬라이드4' />
            </Carousel.Item>
        </Carousel>
    );
}

export default Banner;